import { render, staticRenderFns } from "./tipInfo.vue?vue&type=template&id=21923f76&scoped=true"
import script from "./tipInfo.vue?vue&type=script&lang=js"
export * from "./tipInfo.vue?vue&type=script&lang=js"
import style0 from "./tipInfo.vue?vue&type=style&index=0&id=21923f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21923f76",
  null
  
)

export default component.exports